import { showRequestError } from '../../utils/request-feedback';
import { PermissionControl } from '../../permissions/access';
import { useEffect, useState } from 'react'
import { Button, Popconfirm, Table, Pagination, Typography, Tag, Image } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { MainLayoutUrl } from '../../router/router_path';
import { deleteCourse, fetchCourses } from '../../api/learning';

const LearningCoursesScreen = () => {
    const navigateTo = useNavigate();
    const [tabData, setTabData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    const tabCols = [
        {
            title: 'Course ID',
            dataIndex: 'id',
            key: 'id',
            render: (text, _) => {
                return <Typography.Text copyable>{text}</Typography.Text>
            },
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            width: 200
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            render: (text, _) => {
                return <Tag>{text.name}</Tag>
            }
        },
        {
            title: 'Article Count',
            dataIndex: 'articleCount',
            key: 'articleCount',
        },
        {
            title: 'Cover',
            dataIndex: 'cover',
            key: 'cover',
            render: (text, _) => {
                if (!text) return '';
                return <Image src={text} style={{ maxWidth: 120, maxHeight: 60 }} />
            }
        },
        {
            title: 'Points',
            dataIndex: 'points',
            key: 'points',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record, index) => {
                return (
                    <Button.Group size='small'>
                        <PermissionControl permission="learningcourses.control.editHandle.30f1ec1a"><Button type='link' onClick={() => { editHandle(record) }}>Edit</Button></PermissionControl>
                        <PermissionControl permission="learningcourses.control.deleteHandle.b24c062f"><Popconfirm
                            title="Delete Action"
                            description="Are you sure to delete this course?"
                            onConfirm={() => { deleteHandle(record) }}
                            okText="Yes"
                            cancelText="No" >
                            <Button danger type='link'>Delete</Button>
                        </Popconfirm></PermissionControl>
                    </Button.Group>
                )
            }
        }
    ];

    useEffect(() => {
        getCourses(pageNum, pageSize);
    }, [])

    const getCourses = (pNum, pSize) => {
        setLoading(true);

        let params = {
            'page.num': pNum,
            'page.size': pSize,
        }
        fetchCourses(params).then(res => {
            if (res.list) {
                setTabData(res.list);
            }
            if (res.page) {
                setTotal(res.page.total);
            }
        }).finally(() => setLoading(false)).catch(showRequestError)
    }

    const pageChange = (page, size) => {
        setPageNum(page);
        setPageSize(size);
        getCourses(page, size);
    }

    const editHandle = (record) => {
        navigateTo(MainLayoutUrl.learning.learningcourses.item.path.replace(':id', record.id), { state: { detail: JSON.stringify(record) } })
    }

    const addCourse = () => {
        navigateTo(MainLayoutUrl.learning.learningcourses.item.path.replace(':id', '0'));
    }

    const deleteHandle = (record) => {
        setLoading(true);
        deleteCourse(record.id).then(res => {
            if (res) {
                message.success('deleted!');
                getCourses(pageNum, pageSize);
            }
        }).catch(err => {
            showRequestError(err, err?.message);
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <div className='main-wrapper'>
            <div className='top-part cnt-item'>
                <PermissionControl permission="learningcourses.control.button.62e9f0b7"><Button type='primary' icon={<PlusOutlined />} onClick={addCourse}>Create Course</Button></PermissionControl>
            </div>
            <div className='cnt-item'>
                <Table loading={loading} rowKey={(record) => record.id} rowClassName={'table-row'} size='small' dataSource={tabData} columns={tabCols} pagination={false} />
            </div>
            <div className='footer-part cnt-item'>
                <Pagination
                    total={total}
                    showTotal={(total) => `total ${total}`}
                    current={pageNum}
                    pageSize={pageSize}
                    showSizeChanger={true}
                    pageSizeOptions={[10, 20, 30, 50]}
                    onChange={(page, size) => pageChange(page, size)}
                />
            </div>
        </div>
    )
}

export default LearningCoursesScreen;